import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/auth/forgot/page.tsx");
